import React, { useState, useEffect } from "react"
import Home from "./Home"
import Write from "./Write"
import Feed from "./Feed"
import Login from "./Login"

import { auth } from "./firebase"
import { onAuthStateChanged, signOut } from "firebase/auth"

export default function App() {
  const [page, setPage] = useState<"home" | "write" | "feed">("home")
  const [user, setUser] = useState<any>(null)
  const [showLogin, setShowLogin] = useState(false)

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => {
      setUser(u)
    })
    return () => unsub()
  }, [])

  const navigate = (to: "home" | "write" | "feed") => {
    // 🔒 اگر کاربر لاگین نیست و می‌خواهد Write برود
    if (to === "write" && !user) {
      setShowLogin(true)
      return
    }

    setPage(to)
  }

  const handleLogout = async () => {
    await signOut(auth)
    setUser(null)
    setPage("home")
  }

  // 🔐 اگر باید لاگین نشان داده شود
  if (showLogin) {
    return (
      <Login
        onLogin={() => {
          setShowLogin(false)
          setPage("write")
        }}
      />
    )
  }

  return (
    <div style={{ background: "#020617", minHeight: "100vh", color: "white" }}>
      {/* Header */}
      <div
        style={{
          height: 60,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "0 20px",
          borderBottom: "1px solid #1e293b",
        }}
      >
        <div
          onClick={() => navigate("home")}
          style={{ cursor: "pointer", fontWeight: 700 }}
        >
          CONFES
        </div>

        <div style={{ display: "flex", gap: 12 }}>
          <button onClick={() => navigate("feed")}>Feed</button>
          <button onClick={() => navigate("write")}>Write</button>

          {user ? (
            <button onClick={handleLogout}>Logout</button>
          ) : (
            <button onClick={() => setShowLogin(true)}>Login</button>
          )}
        </div>
      </div>

      {/* Pages */}
      <div style={{ paddingTop: 20 }}>
        {page === "home" && <Home navigate={navigate} />}
        {page === "feed" && <Feed navigate={navigate} />}
        {page === "write" && <Write navigate={navigate} />}
      </div>
    </div>
  )
}